module.exports = __webpack_public_path__ + "img/ubicados.4e57fc76.svg";